// extracted by mini-css-extract-plugin
export default {"wrap":"IB-z","fullWidth":"JB-z","searchPlacement":"KB-z","heading":"LB-z","items":"MB-z","featureCss":"NB-z","disabled":"OB-z","imgCss":"PB-z"};